import { useState } from "react";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { LegislationSaveModel } from "../legislationDialog/LegislationDialog.types";
import { LegislationViewModel } from "./Legislations.types";

import { useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";

export function useLegislationsDataMapping() {
    const queryClient = useDotLegalQueryClient();
    const [showAll, setShowAll] = useStateLocalStorage("onlyActiveLegislations", false);
    const [showLegislationDialog, setShowLegislationDialog] = useState(false);
    const [showDeleteLegislationDialog, setShowDeleteLegislationDialog] = useState(false);
    const [showChangeLegislationStatusDialog, setShowChangeLegislationStatusDialog] = useState(false);
    const [selectedLegislation, setSelectedLegislation] = useState<LegislationSaveModel | undefined>(undefined);

    const queryPart = `?showAllLegislations=${showAll}`;
    const url = `/legislations${queryPart}`;
    let { isLoading, data } = useDotLegalQuery<Array<LegislationViewModel>>(url);

    const OnSave = () => {
        queryClient.refetchQueries(url);
    };

    return {
        isLoading,
        data,
        OnSave,
        showAll,
        setShowAll,
        showLegislationDialog,
        setShowLegislationDialog,
        showDeleteLegislationDialog,
        setShowDeleteLegislationDialog,
        selectedLegislation,
        setSelectedLegislation,
        showChangeLegislationStatusDialog,
        setShowChangeLegislationStatusDialog,
    };
}
